var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "定制服务详情",
        visible: _vm.dialogVisible,
        width: "800px",
        "before-close": _vm.handleClose,
        "close-on-click-modal": false,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      !_vm.orderInfo.tradeList
        ? [
            _c("div", { staticClass: "line-h-20" }, [
              _c("div", { staticClass: "flex mt16" }, [
                _c("div", [_vm._v("订单号：" + _vm._s(_vm.orderInfo.tid))]),
                _c("div", { staticClass: "ml25 flex-1" }, [
                  _vm._v(_vm._s(_vm.orderInfo.receiveName) + " "),
                  _c("span", { staticClass: "ml4" }, [
                    _vm._v(_vm._s(_vm.orderInfo.receiveMobile)),
                  ]),
                  _c("span", { staticClass: "ml4" }, [
                    _vm._v(
                      _vm._s(_vm._f("formatCity")(_vm.orderInfo.receiveCity)) +
                        _vm._s(_vm.orderInfo.receiveAddress)
                    ),
                  ]),
                ]),
              ]),
              _c("div", { staticClass: "flex mt8" }, [
                _c("div", [_vm._v("买家留言：")]),
                _c("div", { staticClass: "flex-1" }, [
                  _vm._v(_vm._s(_vm.orderInfo.buyerFeedback)),
                ]),
              ]),
              _c("div", { staticClass: "flex mt8" }, [
                _c("div", [_vm._v("卖家备注：")]),
                _c("div", { staticClass: "flex-1" }, [
                  _vm._v(_vm._s(_vm.orderInfo.sellerMemo)),
                ]),
              ]),
            ]),
            _vm._l(_vm.orderInfo.orderList, function (item, index) {
              return _c(
                "div",
                { key: index, staticClass: "ml16 mr14" },
                [
                  [
                    ...((item.freeEntryServiceInfo &&
                      JSON.parse(item.freeEntryServiceInfo)) ||
                      []),
                    ...((item.payEntryServiceInfo &&
                      JSON.parse(item.payEntryServiceInfo)) ||
                      []),
                  ].length
                    ? [
                        _c(
                          "el-table",
                          {
                            staticClass: "mt8",
                            staticStyle: { width: "100%" },
                            attrs: {
                              data: [
                                ...((item.freeEntryServiceInfo &&
                                  JSON.parse(item.freeEntryServiceInfo)) ||
                                  []),
                                ...((item.payEntryServiceInfo &&
                                  JSON.parse(item.payEntryServiceInfo)) ||
                                  []),
                              ],
                              "show-header": index == 0,
                              "span-method": (param) =>
                                _vm.spanMethod(param, [
                                  ...((item.freeEntryServiceInfo &&
                                    JSON.parse(item.freeEntryServiceInfo)) ||
                                    []),
                                  ...((item.payEntryServiceInfo &&
                                    JSON.parse(item.payEntryServiceInfo)) ||
                                    []),
                                ]),
                            },
                          },
                          [
                            _c("el-table-column", {
                              attrs: { label: "定制商品", width: "180" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function ({ row }) {
                                      return [
                                        _c("div", { staticClass: "flex" }, [
                                          _c(
                                            "div",
                                            [
                                              _c("el-image", {
                                                staticStyle: {
                                                  width: "58px",
                                                  height: "58px",
                                                },
                                                attrs: {
                                                  src: item.productImgUrl,
                                                  fit: "fill",
                                                  "preview-src-list": [
                                                    item.productImgUrl,
                                                  ],
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "div",
                                            { staticClass: "ml5 line-h-20" },
                                            [
                                              _c("div", [
                                                _vm._v(
                                                  _vm._s(item.name) +
                                                    "/" +
                                                    _vm._s(item.shortName)
                                                ),
                                              ]),
                                              _c("div", [
                                                _vm._v(
                                                  _vm._s(item.quantity) + "件"
                                                ),
                                              ]),
                                            ]
                                          ),
                                        ]),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                            _c("el-table-column", {
                              attrs: { label: "定制服务名称", width: "180" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function ({ row }) {
                                      return [
                                        row.n
                                          ? [_vm._v(" " + _vm._s(row.n) + " ")]
                                          : row.serviceName
                                          ? [
                                              _vm._v(
                                                " " +
                                                  _vm._s(row.serviceName) +
                                                  " "
                                              ),
                                            ]
                                          : _vm._e(),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                            _c("el-table-column", {
                              attrs: { prop: "address", label: "定制服务描述" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function ({ row }) {
                                      return [
                                        row.c
                                          ? _vm._l(
                                              row.c,
                                              function (content, contentIndex) {
                                                return _c(
                                                  "span",
                                                  { key: contentIndex },
                                                  [
                                                    content.split("^")[0] ==
                                                    "text"
                                                      ? [
                                                          _vm._l(
                                                            content
                                                              .split("^")[2]
                                                              .split(","),
                                                            function (
                                                              textItem,
                                                              textIndex
                                                            ) {
                                                              return [
                                                                contentIndex !=
                                                                0
                                                                  ? [
                                                                      _vm._v(
                                                                        "；"
                                                                      ),
                                                                    ]
                                                                  : _vm._e(),
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      _vm._f(
                                                                        "formatText"
                                                                      )(
                                                                        textItem
                                                                      )
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            }
                                                          ),
                                                        ]
                                                      : [
                                                          _vm._l(
                                                            content
                                                              .split("^")[2]
                                                              .split(","),
                                                            function (imgItem) {
                                                              return [
                                                                _c("el-image", {
                                                                  staticStyle: {
                                                                    width:
                                                                      "58px",
                                                                    height:
                                                                      "58px",
                                                                  },
                                                                  attrs: {
                                                                    src: imgItem,
                                                                    fit: "fill",
                                                                    "preview-src-list":
                                                                      content
                                                                        .split(
                                                                          "^"
                                                                        )[2]
                                                                        .split(
                                                                          ","
                                                                        ),
                                                                  },
                                                                }),
                                                              ]
                                                            }
                                                          ),
                                                        ],
                                                  ],
                                                  2
                                                )
                                              }
                                            )
                                          : row.serviceAttriribute
                                          ? [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    row.serviceAttriribute
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          : _vm._e(),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                            _c("el-table-column", {
                              attrs: { prop: "price", label: "单价" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function ({ row }) {
                                      return [
                                        row.servicePrice
                                          ? [
                                              _vm._v(
                                                " " +
                                                  _vm._s(row.servicePrice) +
                                                  " "
                                              ),
                                            ]
                                          : _c("span", [_vm._v("-")]),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        ),
                      ]
                    : _vm._e(),
                ],
                2
              )
            }),
          ]
        : _vm._l(_vm.orderInfo.tradeList, function (item, index) {
            return _c(
              "div",
              { key: index, staticClass: "ml16 mr14" },
              [
                item.entryServiceFlag == 1
                  ? [
                      _c("div", { staticClass: "line-h-20" }, [
                        _c("div", { staticClass: "flex mt16" }, [
                          _c("div", [_vm._v("订单号：" + _vm._s(item.tid))]),
                          _c("div", { staticClass: "ml25 flex-1" }, [
                            _vm._v(_vm._s(item.receiveName) + " "),
                            _c("span", { staticClass: "ml4" }, [
                              _vm._v(_vm._s(item.receiveMobile)),
                            ]),
                            _c("span", { staticClass: "ml4" }, [
                              _vm._v(
                                _vm._s(_vm._f("formatCity")(item.receiveCity)) +
                                  _vm._s(item.receiveAddress)
                              ),
                            ]),
                          ]),
                        ]),
                      ]),
                      _c("div", { staticClass: "mb8" }, [
                        _c("div", { staticClass: "flex mt8" }, [
                          _c("div", [_vm._v("买家留言：")]),
                          _c("div", { staticClass: "flex-1" }, [
                            _vm._v(_vm._s(item.buyerFeedback)),
                          ]),
                        ]),
                        _c("div", { staticClass: "flex mt8" }, [
                          _c("div", [_vm._v("卖家备注：")]),
                          _c("div", { staticClass: "flex-1" }, [
                            _vm._v(_vm._s(item.sellerMemo)),
                          ]),
                        ]),
                      ]),
                      _vm._l(item.orderList, function (orderItem, orderIndex) {
                        return [
                          [
                            ...((orderItem.freeEntryServiceInfo &&
                              JSON.parse(orderItem.freeEntryServiceInfo)) ||
                              []),
                            ...((orderItem.payEntryServiceInfo &&
                              JSON.parse(orderItem.payEntryServiceInfo)) ||
                              []),
                          ].length
                            ? [
                                _c(
                                  "el-table",
                                  {
                                    staticClass: "mt8",
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      data: [
                                        ...((orderItem.freeEntryServiceInfo &&
                                          JSON.parse(
                                            orderItem.freeEntryServiceInfo
                                          )) ||
                                          []),
                                        ...((orderItem.payEntryServiceInfo &&
                                          JSON.parse(
                                            orderItem.payEntryServiceInfo
                                          )) ||
                                          []),
                                      ],
                                      "show-header": orderIndex == 0,
                                      "span-method": (param) =>
                                        _vm.spanMethod(param, [
                                          ...((orderItem.freeEntryServiceInfo &&
                                            JSON.parse(
                                              orderItem.freeEntryServiceInfo
                                            )) ||
                                            []),
                                          ...((orderItem.payEntryServiceInfo &&
                                            JSON.parse(
                                              orderItem.payEntryServiceInfo
                                            )) ||
                                            []),
                                        ]),
                                    },
                                  },
                                  [
                                    _c("el-table-column", {
                                      attrs: {
                                        label: "定制商品",
                                        width: "180",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function ({ row }) {
                                              return [
                                                _c(
                                                  "div",
                                                  { staticClass: "flex" },
                                                  [
                                                    _c(
                                                      "div",
                                                      [
                                                        _c("el-image", {
                                                          staticStyle: {
                                                            width: "58px",
                                                            height: "58px",
                                                          },
                                                          attrs: {
                                                            src: orderItem.productImgUrl,
                                                            fit: "fill",
                                                            "preview-src-list":
                                                              [
                                                                orderItem.productImgUrl,
                                                              ],
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "ml5 line-h-20",
                                                      },
                                                      [
                                                        _c("div", [
                                                          _vm._v(
                                                            _vm._s(
                                                              orderItem.name
                                                            ) +
                                                              "/" +
                                                              _vm._s(
                                                                orderItem.shortName
                                                              )
                                                          ),
                                                        ]),
                                                        _c("div", [
                                                          _vm._v(
                                                            _vm._s(
                                                              orderItem.quantity
                                                            ) + "件"
                                                          ),
                                                        ]),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                    _c("el-table-column", {
                                      attrs: {
                                        label: "定制服务名称",
                                        width: "180",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function ({ row }) {
                                              return [
                                                row.n
                                                  ? [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(row.n) +
                                                          " "
                                                      ),
                                                    ]
                                                  : row.serviceName
                                                  ? [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            row.serviceName
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  : _vm._e(),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "address",
                                        label: "定制服务描述",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function ({ row }) {
                                              return [
                                                row.c
                                                  ? _vm._l(
                                                      row.c,
                                                      function (
                                                        content,
                                                        contentIndex
                                                      ) {
                                                        return _c(
                                                          "span",
                                                          { key: contentIndex },
                                                          [
                                                            content.split(
                                                              "^"
                                                            )[0] == "text"
                                                              ? [
                                                                  _vm._l(
                                                                    content
                                                                      .split(
                                                                        "^"
                                                                      )[2]
                                                                      .split(
                                                                        ","
                                                                      ),
                                                                    function (
                                                                      textItem,
                                                                      textIndex
                                                                    ) {
                                                                      return [
                                                                        contentIndex !=
                                                                        0
                                                                          ? [
                                                                              _vm._v(
                                                                                "；"
                                                                              ),
                                                                            ]
                                                                          : _vm._e(),
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              _vm._f(
                                                                                "formatText"
                                                                              )(
                                                                                textItem
                                                                              )
                                                                            ) +
                                                                            " "
                                                                        ),
                                                                      ]
                                                                    }
                                                                  ),
                                                                ]
                                                              : [
                                                                  _vm._l(
                                                                    content
                                                                      .split(
                                                                        "^"
                                                                      )[2]
                                                                      .split(
                                                                        ","
                                                                      ),
                                                                    function (
                                                                      imgItem
                                                                    ) {
                                                                      return [
                                                                        _c(
                                                                          "el-image",
                                                                          {
                                                                            staticStyle:
                                                                              {
                                                                                width:
                                                                                  "58px",
                                                                                height:
                                                                                  "58px",
                                                                              },
                                                                            attrs:
                                                                              {
                                                                                src: imgItem,
                                                                                fit: "fill",
                                                                                "preview-src-list":
                                                                                  content
                                                                                    .split(
                                                                                      "^"
                                                                                    )[2]
                                                                                    .split(
                                                                                      ","
                                                                                    ),
                                                                              },
                                                                          }
                                                                        ),
                                                                      ]
                                                                    }
                                                                  ),
                                                                ],
                                                          ],
                                                          2
                                                        )
                                                      }
                                                    )
                                                  : row.serviceAttriribute
                                                  ? [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            row.serviceAttriribute
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  : _vm._e(),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                    _c("el-table-column", {
                                      attrs: { prop: "price", label: "单价" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function ({ row }) {
                                              return [
                                                row.servicePrice
                                                  ? [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            row.servicePrice
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  : _c("span", [_vm._v("-")]),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            : _vm._e(),
                        ]
                      }),
                    ]
                  : _vm._e(),
              ],
              2
            )
          }),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function ($event) {
                  _vm.dialogVisible = false
                },
              },
            },
            [_vm._v("确 定")]
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }